import { render } from "./SelectPatient.vue?vue&type=template&id=2807e3a4&scoped=true&lang=pug"
import script from "./SelectPatient.vue?vue&type=script&lang=js"
export * from "./SelectPatient.vue?vue&type=script&lang=js"

import "./SelectPatient.vue?vue&type=style&index=0&id=2807e3a4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2807e3a4"]])

export default __exports__